import React from "react";
import { Box, Typography } from "@mui/material";

export const ChooseActionStep = () => {
  return (
    <Box>
      <Typography variant="body1" gutterBottom sx={{ p: 0 }}>
        You have unsaved changes that will be lost if you navigate away without
        saving. Please discard your edits or save them to trigger a new run.
      </Typography>
    </Box>
  );
};
